export enum UserRole {
  USER = 'user',
  ADMIN = 'admin',
  OWNER = 'owner',
}

export type UserAccessKind = 'admin' | 'owner' | 'member' | 'mixed';

export interface UserAccessLocation {
  locationId: number,
  isOwner: boolean,
  // Effective per-location value: already ANDed with the owner's own rentals
  // feature. Never recombine it with anything else.
  rentalEnabled: boolean,
}

export interface UserAccess {
  // `admin` => `locations` is empty and means EVERYTHING.
  // `mixed` => owns some locations and is a teammate on others.
  kind: UserAccessKind,
  locations: UserAccessLocation[],
}

export interface User {
  id: string,
  email: string,
  firstName: string,
  lastName: string,
  birthdate?: string,
  phone?: string,
  addressStreet?: string,
  addressStreet2?: string,
  addressPostalCode?: string,
  addressCity?: string,
  addressCountry?: string,
  sosFirstname?: string,
  sosLastname?: string,
  sosPhone?: string,
  stripeId?: string,
  role: UserRole,
  token: string,
  lang: string,
  // Legacy flat flag: for a member it is true when ANY reachable location
  // grants rentals. Prefer `access.locations[].rentalEnabled` when scoped to a
  // single location; this stays as the fallback against an older API.
  rentalEnabled: boolean,
  subscription?: { name: string; maxStations: number | null } | null,
  // Optional so the app degrades gracefully against an API that predates teams.
  access?: UserAccess,
}

export interface UserForRegistration {
  email: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  lastName: string;
  termsAccepted: boolean;
  lang: string;
}

// password regex: 8 characters min, 1 uppercase, 1 lowercase, 1 number
export const REGEX_PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
export const REGEX_EMAIL = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;